export default __webpack_public_path__ + "static/media/1303.da736dc2.png";